module.exports = __webpack_public_path__ + "photogallery.css";


//////////////////
// WEBPACK FOOTER
// ./app/photogallery.scss
// module id = 1
// module chunks = 0